// extracted by mini-css-extract-plugin
export var footnoteContent = "FootnotesSection-module--footnoteContent--93143";
export var footnoteItem = "FootnotesSection-module--footnoteItem--13b52";
export var footnoteNumber = "FootnotesSection-module--footnoteNumber--3a641";
export var footnotesContainer = "FootnotesSection-module--footnotesContainer--1bcd9";
export var footnotesList = "FootnotesSection-module--footnotesList--3ec2c";
export var footnotesTitle = "FootnotesSection-module--footnotesTitle--ff547";